<template>
  <div class="companyBox">
    <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
      <Form-item label="考勤年月：" prop="attendanceDate">
        <DatePicker v-model="formCustom.attendanceDate" style="width: 200px" type="month"/>
      </Form-item>
      <Form-item label="所属公司：" prop="companyName">
        <Input
          v-model="formCustom.companyName"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="所属厂站：" prop="deptName">
        <Input
          v-model="formCustom.deptName"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <br>
      <Form-item label="考勤人数：" prop="attendanceNumber">
        <Input
          v-model="formCustom.attendanceNumber"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item
        label="状态："
        prop="auditStatus"
      >
        <Select
          v-model="formCustom.auditStatus"
          clearable
          filterable
          style="width: 200px"
        >
          <Option v-if="roleType == 1" value="1">待提交</Option>
          <Option v-if="roleType == 1" value="2">待审核</Option>
          <Option v-if="roleType == 1" value="4">部分拒绝</Option>
          <Option v-if="roleType == 1" value="3">完成</Option>
          <Option v-if="roleType == 2 || roleType == 5" value="2">待审核</Option>
          <Option v-if="roleType == 2 || roleType == 5" value="4">已审核</Option>
          <Option v-if="roleType == 2 || roleType == 5" value="3">完成</Option>
          <Option v-if="roleType == 4 || roleType == 3" value="3">待确认</Option>
          <Option v-if="roleType == 4 || roleType == 3" value="5">已确认</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')"
        >重置
        </Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button v-if="roleType == 1" type="primary" @click="addOrganization()"
      >上传考勤
      </Button
      >
      <Button
        v-if="roleType == 3 || roleType == 4"
        :disabled="companyAttendanceIds == ''"
        type="primary"
        @click="outs()"
      >
        批量导出
      </Button>
    </div>
    <div>
      <Table
        ref="multipleTable"
        :columns="
          roleType === 1 || roleType === 2 || roleType === 5
            ? companyColumnsNoSelection
            : companyColumns
        "
        :data="companyTableData"
        :loading="loading"
        aria-describedby=""
        aria-hidden="true"
        border @on-selection-change="selectionChange"
      >
        <template slot="action" slot-scope="{ row }">
          <Button size="small" type="text" @click="check(row)">查看</Button>
          <Button
            v-if="
              (row.auditStatus == 1 || row.auditStatus == 4) && roleType == 1
            "
            size="small"
            type="text"
            @click="editOrganization(row)"
          >编辑
          </Button>
          <Button
            v-if="row.auditStatus == 2 && roleType == 1"
            size="small"
            type="text"
            @click="cancelSubmit(row)"
          >撤回
          </Button>
          <Button
            v-if="
              row.auditStatus == 1 && roleType == 1
            "
            size="small"
            type="text"
            @click="submitAudit(row)"
          >提交审核
          </Button>
          <Button
            v-if="(roleType == 2 || roleType == 5) && row.auditStatus == 2 && row.auditWaitCount > 0"
            size="small"
            type="text"
            @click="audit(row)"
          >审核
          </Button>
          <Button
            v-if="(roleType == 3 || roleType == 4) && row.auditStatus == 5"
            size="small"
            type="text"
            @click="out(row)"
          >导出
          </Button>
          <Button
            v-if="row.auditStatus == 3 && (roleType == 3 || roleType == 4)"
            size="small"
            type="text"
            @click="affirm(row)"
          >去处理
          </Button>
          <Button v-if="(row.auditStatus == 3 || row.auditStatus == 5) && roleType == 4" size="small" type="text"
                  @click="rollback(row.companyAttendanceId)">退回
          </Button>
        </template>
        <template slot="auditStatus" slot-scope="{ row }">
          {{
            row.auditStatus == 1 ? "待提交" : row.auditStatus == 2
              ? "待审核"
              : row.auditStatus == 3 && roleType == 4
                ? "待确认"
                : row.auditStatus == 3 && roleType == 3
                  ? "待确认"
                  : row.auditStatus == 3 && roleType == 2
                    ? "完成"
                    : row.auditStatus == 3 && roleType == 5
                      ? "完成"
                      : row.auditStatus == 3 && roleType == 1
                        ? "完成"
                        : row.auditStatus == 4 && roleType == 1
                          ? "部分拒绝"
                          : row.auditStatus == 4 && roleType == 2
                            ? "已审核"
                            : row.auditStatus == 4 && roleType == 5
                              ? "已审核"
                              : row.auditStatus == 5 && roleType == 3
                                ? "已确认"
                                : row.auditStatus == 5 && roleType == 4
                                  ? "已确认"
                                  : '完成'
          }}
        </template>
      </Table>
      <Page
        ref="pages"
        :current="page"
        :total="total"
        class="page_position"
        show-elevator
        show-sizer
        show-total
        @on-change="setCurrent"
        @on-page-size-change="setPage"
      ></Page>
    </div>
    <el-dialog :visible.sync="dialogaffirm" title="考勤表确认" width="1200px" @close="close">
      <Table
        :columns="columnsaffirm"
        :data="tableDataaffirm"
        :loading="loadingaffirm"
        aria-describedby=""
        aria-hidden="true" border
      >
        <template slot="employeeAttendanceDays" slot-scope="scope">
          <span
            v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">{{
              scope.row.employeeAttendanceDays
            }}</span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeAttendanceDays"
                    style="width:50px">
          </el-input>
        </template>
        <template slot="employeeNightDays" slot-scope="scope">
          <span
            v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">{{
              scope.row.employeeNightDays
            }}</span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeNightDays"
                    style="width:50px">
          </el-input>
        </template>
        <template slot="employeeBusinessDays" slot-scope="scope">
          <span v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">
            {{ scope.row.employeeBusinessDays }}
          </span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeBusinessDays"
                    style="width:50px">
          </el-input>
        </template>
        <template slot="employeeWeekendOvertimeDays" slot-scope="scope">
          <span v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">
            {{ scope.row.employeeWeekendOvertimeDays }}
          </span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeWeekendOvertimeDays"
                    style="width:50px">
          </el-input>
        </template>
        <template slot="employeeHolidayOvertimeDays" slot-scope="scope">
          <span v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">
            {{ scope.row.employeeHolidayOvertimeDays }}
          </span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeHolidayOvertimeDays"
                    style="width:50px">
          </el-input>
        </template>
        <template slot="employeeBusWorkCount" slot-scope="scope">
          <span v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">
            {{ scope.row.employeeBusWorkCount }}
          </span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeBusWorkCount"
                    style="width:50px">
          </el-input>
        </template>
        <template slot="employeeTransferCount" slot-scope="scope">
          <span v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">
            {{ scope.row.employeeTransferCount }}
          </span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeTransferCount"
                    style="width:50px">
          </el-input>
        </template>
        <template slot="employeeLeaveDays" slot-scope="scope">
          <span v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">
            {{ scope.row.employeeLeaveDays }}
          </span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeLeaveDays"
                    style="width:50px">
          </el-input>
        </template>
        <template slot="employeeOther" slot-scope="scope">
          <span v-show="scope.row.companyAttendanceRecordId != rowaffirm.companyAttendanceRecordId">
            {{ scope.row.employeeOther }}
          </span>
          <el-input v-show="scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId"
                    v-model="fromAffirm.employeeOther"
                    style="width:50px">
          </el-input>
        </template>

        <template slot="action" slot-scope="scope">
          <Button size="small" type="text" @click="edit(scope)">
            {{ scope.row.companyAttendanceRecordId == rowaffirm.companyAttendanceRecordId ? '保存' : '编辑' }}
          </Button>
        </template>
      </Table>
      <Page
        ref="pageaffirm"
        :current="pageaffirm"
        :total="totalaffirm"
        class="page_position"
        show-elevator
        show-sizer
        show-total
        style="margin-bottom: 50px"
        @on-change="setCurrentaffirm"
        @on-page-size-change="setPageaffirm"
      ></Page>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="affirmclick">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" title="审核" width="500px">
      <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
        <FormItem label="审核结果：">
          <el-radio v-model="asyncRoute.pass" label="1">审核通过</el-radio>
          <el-radio v-model="asyncRoute.pass" label="2">审核拒绝</el-radio>
        </FormItem>
        <Form-item label="审核意见：">
          <Input
            v-model="asyncRoute.checkIdea"
            clearable
            style="width: 200px"
            type="textarea"
          ></Input>
        </Form-item>
      </Form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditclick">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogTableVisible" title="考勤表" width="1000px" @close="close">
      <el-tabs v-model="activeName">
        <el-tab-pane name="1">
          <span slot="label" :style="{color:(red1 && roleType == 1 ? 'red' : '')}">节假日加班审批表</span>
          <div>
            <Table
              :columns="isput ? columns1 : kcolumns1"
              :data="tableData1"
              :loading="loading1"
              aria-describedby=""
              aria-hidden="true"
              border @on-selection-change="selectionChanges"
            >
              <template slot="auditStatus" slot-scope="{ row }">
                {{
                  row.auditStatus == 1
                    ? "待提交"
                    : row.auditStatus == 2
                      ? "待审核"
                      : row.auditStatus == 3
                        ? "审核通过"
                        : row.auditStatus == 4
                          ? "审核拒绝"
                          : "待车管员审核"
                }}
              </template>
            </Table>
            <Page
              ref="pages1"
              :current="page1"
              :total="total1"
              class="page_position"
              show-elevator
              show-sizer
              show-total
              style="margin-bottom: 10px"
              @on-change="setCurrentb"
              @on-page-size-change="setPageb"
            ></Page>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label" :style="{color:(red2 && roleType == 1 ? 'red' : '')}">双休加班审批表</span>
          <div>
            <Table
              :columns="isput ? columns2 : kcolumns2"
              :data="tableData2"
              :loading="loading2"
              aria-describedby=""
              aria-hidden="true"
              border @on-selection-change="selectionChanges"
            >
              <template slot="auditStatus" slot-scope="{ row }">
                {{
                  row.auditStatus == 1
                    ? "待提交"
                    : row.auditStatus == 2
                      ? "待审核"
                      : row.auditStatus == 3
                        ? "审核通过"
                        : row.auditStatus == 4
                          ? "审核拒绝"
                          : "待车管员审核"
                }}
              </template>
            </Table>
            <Page
              ref="pages2"
              :current="page2"
              :total="total2"
              class="page_position"
              show-elevator
              show-sizer
              show-total
              style="margin-bottom: 80px"
              @on-change="setCurrentb"
              @on-page-size-change="setPageb"
            ></Page>
          </div>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label" :style="{color:(red3 && roleType == 1 ? 'red' : '')}">出差确认表</span>
          <div>
            <Table
              :columns="isput ? columns3 : kcolumns3"
              :data="tableData3"
              :loading="loading3"
              aria-describedby=""
              aria-hidden="true"
              border @on-selection-change="selectionChanges"
            >
              <template slot="auditStatus" slot-scope="{ row }">
                {{
                  row.auditStatus == 1
                    ? "待提交"
                    : row.auditStatus == 2
                      ? "待审核"
                      : row.auditStatus == 3
                        ? "审核通过"
                        : row.auditStatus == 4
                          ? "审核拒绝"
                          : "待车管员审核"
                }}
              </template>
            </Table>
            <Page
              ref="pages3"
              :current="page3"
              :total="total3"
              class="page_position"
              show-elevator
              show-sizer
              show-total
              style="margin-bottom: 80px"
              @on-change="setCurrentb"
              @on-page-size-change="setPageb"
            ></Page>
          </div>
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label" :style="{color:(red4 && roleType == 1 ? 'red' : '')}">夜餐补助审批表</span>
          <div>
            <Table
              :columns="isput ? columns4 : kcolumns4"
              :data="tableData4"
              :loading="loading4"
              aria-describedby=""
              aria-hidden="true"
              border @on-selection-change="selectionChanges"
            >
              <template slot="auditStatus" slot-scope="{ row }">
                {{
                  row.auditStatus == 1
                    ? "待提交"
                    : row.auditStatus == 2
                      ? "待审核"
                      : row.auditStatus == 3
                        ? "审核通过"
                        : row.auditStatus == 4
                          ? "审核拒绝"
                          : "待车管员审核"
                }}
              </template>
            </Table>
            <Page
              ref="pages4"
              :current="page4"
              :total="total4"
              class="page_position"
              show-elevator
              show-sizer
              show-total
              style="margin-bottom: 80px"
              @on-change="setCurrentb"
              @on-page-size-change="setPageb"
            ></Page>
          </div>
        </el-tab-pane>
        <el-tab-pane name="6">
          <span slot="label" :style="{color:(red6 && roleType == 1 ? 'red' : '')}">请假审批表</span>
          <div>
            <Table
              :columns="isput ? columns6 : kcolumns6"
              :data="tableData6"
              :loading="loading6"
              aria-describedby=""
              aria-hidden="true"
              border @on-selection-change="selectionChanges"
            >
              <template slot="leaveUrl" slot-scope="{ row }">
                <Button v-if="row.leaveUrl" size="small" type="text" @click="leaveShow(row)">请假单</Button>
              </template>
              <template slot="auditStatus" slot-scope="{ row }">
                {{
                  row.auditStatus == 1
                    ? "待提交"
                    : row.auditStatus == 2
                      ? "待审核"
                      : row.auditStatus == 3
                        ? "审核通过"
                        : row.auditStatus == 4
                          ? "审核拒绝"
                          : "待车管员审核"
                }}
              </template>
            </Table>
            <Page
              ref="pages6"
              :current="page6"
              :total="total6"
              class="page_position"
              show-elevator
              show-sizer
              show-total
              style="margin-bottom: 80px"
              @on-change="setCurrentb"
              @on-page-size-change="setPageb"
            ></Page>
          </div>
        </el-tab-pane>
        <el-tab-pane name="5">
          <span slot="label">考勤统计表</span>
          <div>
            <Table
              :columns="(this.roleType === 0 || this.roleType === 3 || this.roleType === 4) ? columns : columnsNoIdNumber"
              :data="tableData5"
              :loading="loading5"
              aria-describedby=""
              aria-hidden="true" border
            >
              <template slot="auditStatus" slot-scope="{ row }">
                {{
                  row.auditStatus == 1
                    ? "待提交"
                    : row.auditStatus == 2
                      ? "待审核"
                      : row.auditStatus == 3
                        ? "审核通过"
                        : "审核拒绝"
                }}
              </template>
            </Table>
            <Page
              ref="pages5"
              :current="page5"
              :total="total5"
              class="page_position"
              show-elevator
              show-sizer
              show-total
              style="margin-bottom: 50px"
              @on-change="setCurrentb"
              @on-page-size-change="setPageb"
            ></Page>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div v-if="isput && activeName!=5">
        <Button type="primary" @click="audits">审核</Button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import permissionList from "@/libs/handlePermission.ts";
import {
  companyAttendanceAudit,
  companyAttendanceBusinessAudit,
  companyAttendanceBusinessPage,
  companyAttendanceCancelSubmit,
  companyAttendanceHolidayAudit,
  companyAttendanceHolidayPage,
  companyAttendanceLeaveAudit,
  companyAttendanceLeavePage,
  companyAttendanceNightAudit,
  companyAttendanceNightPage,
  companyAttendancePage,
  companyAttendanceRecordPage,
  companyAttendanceRecordPut,
  companyAttendanceRollback,
  companyAttendanceSubmitAudit,
  companyAttendanceWeekendAudit,
  companyAttendanceWeekendPage
} from "@/api/attendance";
import axios from "axios";

export default {
  name: "company",
  data() {
    return {
      rows: [],
      ischeck: false,
      rowaffirm: {},
      fromAffirm: {
        employeeAttendanceDays: '',
        employeeNightDays: '',
        employeeBusinessDays: '',
        employeeWeekendOvertimeDays: '',
        employeeHolidayOvertimeDays: '',
        employeeBusWorkCount: '',
        employeeTransferCount: '',
        employeeLeaveDays: '',
        employeeOther: ''
      },
      activeName: "1",
      dialogVisible: false,
      dialogTableVisible: false,
      tableData: [],
      total: 0,
      page: 1,
      dialogtotal: 0,
      dialogpage: 1,
      dialogloading: false,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      formCustom: {},
      asyncRoute: {
        pass: "1",
        checkIdea: "",
      },
      dialogaffirm: false,
      loadingaffirm: false,
      totalaffirm: 0,
      pageaffirm: 1,
      sizeaffirm: 10,
      pageSizeaffirm: 10,
      tableDataaffirm: [],
      columnsaffirm: [
        {type: "index", title: "序号", align: "left"},
        {title: "所属公司", key: "companyName", align: "left"},
        {title: "所属厂站", key: "deptName", align: "left"},
        {title: "姓名", key: "employeeRealName", align: "left"},
        {title: "身份证号", key: "employeeIdNumber", align: "left"},
        {title: "职务", key: "employeePositionName", align: "left"},
        {
          title: "出勤天数",
          slot: 'employeeAttendanceDays',
          width: '80px',
          key: "employeeAttendanceDays",
          align: "center"
        },
        {title: "晚班", slot: 'employeeNightDays', width: '80px', key: "employeeNightDays", align: "center"},
        {title: "出差天数", slot: 'employeeBusinessDays', width: '80px', key: "employeeBusinessDays", align: "center"},
        {
          title: "双休加班",
          key: "employeeWeekendOvertimeDays",
          align: "center",
          slot: 'employeeWeekendOvertimeDays', width: '80px',
        },
        {
          title: "节假日加班",
          key: "employeeHolidayOvertimeDays",
          align: "center",
          slot: 'employeeHolidayOvertimeDays', width: '80px',
        },
        {
          title: "中巴车出车",
          slot: 'employeeBusWorkCount',
          width: '80px',
          key: "employeeBusWorkCount",
          align: "center"
        },
        {
          title: "换乘费次数",
          slot: 'employeeTransferCount',
          width: '80px',
          key: "employeeTransferCount",
          align: "center"
        },
        {
          title: "请假天数",
          slot: 'employeeLeaveDays',
          width: '80px',
          key: "employeeLeaveDays",
          align: "center"
        },
        {title: "其他", slot: 'employeeOther', width: '80px', key: "employeeOther", align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      companyColumns: [
        {type: "selection", width: 60},
        {type: "index", title: "序号", width: 70, align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "考勤年月", key: "attendanceDate", width: 100, align: "center"},
        {title: "考勤人数", key: "attendanceNumber", width: 100, align: "center"},
        {title: "创建时间", key: "createTime", width: 160, align: "center"},
        {title: "提交审核时间", key: "submitTime", width: 160, align: "center"},
        {title: "状态", slot: "auditStatus", key: "auditStatus", width: 90, align: "center"},
        {title: "处理时间", key: "auditTime", width: 160, align: "center"},
        {title: "操作", slot: "action", width: 160, align: "center", fixed: "right"}
      ],
      companyColumnsNoSelection: [
        {type: "index", title: "序号", width: 70, align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "考勤年月", key: "attendanceDate", width: 100, align: "center"},
        {title: "考勤人数", key: "attendanceNumber", width: 100, align: "center"},
        {title: "创建时间", key: "createTime", width: 160, align: "center"},
        {title: "提交审核时间", key: "submitTime", width: 160, align: "center"},
        {title: "状态", slot: "auditStatus", key: "auditStatus", width: 90, align: "center"},
        {title: "操作", slot: "action", width: 200, align: "center", fixed: "right"}
      ],
      companyTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: "",
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      addDialogVisible: false,
      editDialogVisible: false,
      roleType: "",
      companyAttendanceIds: "",
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "left"},
        {title: "所属厂站", key: "deptName", align: "left"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "身份证号", key: "employeeIdNumber", align: "center"},
        {title: "职务", key: "employeePositionName", align: "center"},
        {title: "出勤天数", key: "employeeAttendanceDays", align: "center"},
        {title: "晚班", key: "employeeNightDays", align: "center"},
        {title: "出差天数", key: "employeeBusinessDays", align: "center"},
        {
          title: "双休加班",
          key: "employeeWeekendOvertimeDays",
          align: "center",
        },
        {
          title: "节假日加班",
          key: "employeeHolidayOvertimeDays",
          align: "center",
        },
        {title: "中巴车出车", key: "employeeBusWorkCount", align: "center"},
        {title: "换乘费次数", key: "employeeTransferCount", align: "center"},
        {title: "请假天数", key: "employeeLeaveDays", align: "center"},
        {title: "其他", key: "employeeOther", align: "center"},
      ],
      columnsNoIdNumber: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "left"},
        {title: "所属厂站", key: "deptName", align: "left"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "职务", key: "employeePositionName", align: "center"},
        {title: "出勤天数", key: "employeeAttendanceDays", align: "center"},
        {title: "晚班", key: "employeeNightDays", align: "center"},
        {title: "出差天数", key: "employeeBusinessDays", align: "center"},
        {
          title: "双休加班",
          key: "employeeWeekendOvertimeDays",
          align: "center",
        },
        {
          title: "节假日加班",
          key: "employeeHolidayOvertimeDays",
          align: "center",
        },
        {title: "中巴车出车", key: "employeeBusWorkCount", align: "center"},
        {title: "换乘费次数", key: "employeeTransferCount", align: "center"},
        {title: "请假天数", key: "employeeLeaveDays", align: "center"},
        {title: "其他", key: "employeeOther", align: "center"},
      ],
      tableData5: [],
      loading5: false,
      total5: 0,
      page5: 1,
      size5: 10,
      pageSize5: 10,
      showTable5: false,
      kcolumns2: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "weekendDate", align: "center"},
        {title: "加班时间", key: "weekendDays", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "weekendCause", align: "center"},
        {title: "是否调休", key: "isChangeTime", align: "center"},
        {title: "是否申请加班工资", key: "isChangeAmount", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      columns2: [
        {type: "selection"},
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "weekendDate", align: "center"},
        {title: "加班时间", key: "weekendDays", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "weekendCause", align: "center"},
        {title: "是否调休", key: "isChangeTime", align: "center"},
        {title: "是否申请加班工资", key: "isChangeAmount", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData1: [],
      loading1: false,
      total1: 0,
      page1: 1,
      size1: 10,
      pageSize1: 10,
      showTable1: false,
      kcolumns1: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "holidayDate", align: "center"},
        {title: "加班时间", key: "holidayDays", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "holidayCause", align: "center"},
        {title: "是否调休", key: "isChangeTime", align: "center"},
        {title: "是否申请加班工资", key: "isChangeAmount", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      columns1: [
        {
          type: "selection", selectable: (row) => {
            return false
          }
        },
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "holidayDate", align: "center"},
        {title: "加班时间", key: "holidayDays", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "holidayCause", align: "center"},
        {title: "是否调休", key: "isChangeTime", align: "center"},
        {title: "是否申请加班工资", key: "isChangeAmount", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData2: [],
      loading2: false,
      total2: 0,
      page2: 1,
      size2: 10,
      pageSize2: 10,
      showTable2: false,
      columns3: [
        {type: "selection"},
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "起始日期", key: "businessDate", align: "center"},
        {title: "目的地", key: "businessDestination", align: "center"},
        {title: "同行人签字", key: "businessFellow", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      kcolumns3: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "起始日期", key: "businessDate", align: "center"},
        {title: "目的地", key: "businessDestination", align: "center"},
        {title: "同行人签字", key: "businessFellow", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData3: [],
      loading3: false,
      total3: 0,
      page3: 1,
      size3: 10,
      pageSize3: 10,
      showTable3: false,
      columns4: [
        {type: "selection"},
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "nightDate", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "nightCause", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      kcolumns4: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "日期", key: "nightDate", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "事由", key: "nightCause", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData4: [],
      loading4: false,
      total4: 0,
      page4: 1,
      size4: 10,
      pageSize4: 10,
      showTable4: false,
      columns6: [
        {type: "selection"},
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "请假起止日期", key: "leaveDate", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "实际请假天数", key: "leaveDays", align: "center"},
        {title: "请假类型", key: "leaveType", align: "center"},
        {title: "事由", key: "leaveCause", align: "center"},
        {title: "附件", slot: "leaveUrl", key: "leaveUrl", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      kcolumns6: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "请假起止日期", key: "leaveDate", align: "center"},
        {title: "申请人", key: "employeeRealName", align: "center"},
        {title: "实际请假天数", key: "leaveDays", align: "center"},
        {title: "请假类型", key: "leaveType", align: "center"},
        {title: "事由", key: "leaveCause", align: "center"},
        {title: "附件", slot: "leaveUrl", key: "leaveUrl", align: "center"},
        {
          title: "状态",
          key: "auditStatus",
          slot: "auditStatus",
          align: "center",
        },
        {title: "审核意见", key: "auditIdea", align: "center"},
      ],
      tableData6: [],
      loading6: false,
      total6: 0,
      page6: 1,
      size6: 10,
      pageSize6: 10,
      showTable6: false,
      isput: false,
      subjectIds: "",
      subjectIdsw: "",
      subjectIdsb: "",
      subjectIdsn: "",
      subjectIdsl: "",
      red1: false,
      red2: false,
      red3: false,
      red4: false,
      red6: false,
    };
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"));
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList();
    this.init();
    let token = localStorage.getItem("getToken");
    let userString = decodeURIComponent(
      window.atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
    );
    let user = JSON.parse(userString);
    this.roleType = user.roleType;
    console.log(this.roleType);
  },
  methods: {
    // 初始化
    init() {
      this.loading = true;
      companyAttendancePage({
        current: 1,
        size: 10,
      }).then((res) => {
        this.changeData(res);
      });
    },
    selectionChange(rows) {
      this.$nextTick(() => {
        if (rows && rows.length > 0) {
          let ids = [];
          rows.forEach((row) => {
            if (row.auditStatus === 5) {
              ids.push(row.companyAttendanceId);
            }
          });
          this.rows = rows
          this.companyAttendanceIds = ids.join(",");
        } else {
          this.companyAttendanceIds = "";
        }
      })
    },
    leaveShow(row) {
      row.leaveUrl.split(",").forEach((e) => {
        window.open(e, '_blank')
      })
    },
    selectionChanges(rows) {
      if (this.activeName == 1) {
        if (rows && rows.length > 0) {
          let ids = [];
          rows.forEach((row) => {
            ids.push(row.companyAttendanceHolidayId);
          });
          this.subjectIds = ids.join(",");
        } else {
          this.subjectIds = "";
        }
      }
      if (this.activeName == 2) {
        console.log(rows)
        if (rows && rows.length > 0) {
          let ids = [];
          rows.forEach((row) => {
            ids.push(row.companyAttendanceWeekendId);
          });
          this.subjectIdsw = ids.join(",");
        } else {
          this.subjectIdsw = "";
        }
      }
      if (this.activeName == 3) {
        if (rows && rows.length > 0) {
          let ids = [];
          rows.forEach((row) => {
            ids.push(row.companyAttendanceBusinessId);
          });
          this.subjectIdsb = ids.join(",");
        } else {
          this.subjectIdsb = "";
        }
      }
      if (this.activeName == 4) {
        if (rows && rows.length > 0) {
          let ids = [];
          rows.forEach((row) => {
            ids.push(row.companyAttendanceNightId);
          });
          this.subjectIdsn = ids.join(",");
        } else {
          this.subjectIdsn = "";
        }
      }
      if (this.activeName == 6) {
        if (rows && rows.length > 0) {
          let ids = [];
          rows.forEach((row) => {
            ids.push(row.companyAttendanceLeaveId);
          });
          this.subjectIdsl = ids.join(",");
        } else {
          this.subjectIdsl = "";
        }
      }
    },
    check(row) {
      //查看详情
      this.row = row;
      this.isput = false;
      companyAttendanceRecordPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.dialogchangeData(5, res);
        this.dialogTableVisible = true;
      });
      companyAttendanceHolidayPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(1, res1);
      });
      companyAttendanceWeekendPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(2, res1);
      });
      companyAttendanceBusinessPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(3, res1);
      });
      companyAttendanceNightPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(4, res1);
      });
      companyAttendanceLeavePage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(6, res1);
      });
    },
    // 查询
    handleSearch() {
      this.loading = true;
      companyAttendancePage({
        current: 1,
        size: this.pageSize,
        attendanceDate:
          this.formCustom.attendanceDate &&
          this.$moment(this.formCustom.attendanceDate).format("YYYY-MM"),
        companyName: this.formCustom.companyName,
        deptName: this.formCustom.deptName,
        attendanceNumber: this.formCustom.attendanceNumber,
        auditStatus: this.formCustom.auditStatus,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.companyTableData = res.data.data.records;
      this.loading = false;
    },
    dialogchangeDataaffirm(res) {
      this.totalaffirm = res.data.data.total;
      this.sizeaffirm = res.data.data.size;
      this.tableDataaffirm = res.data.data.records;
      this.loadingaffirm = false;
    },
    dialogchangeData(v, res) {
      if (res) {
        if (v == 1) {
          this.total1 = res.data.data.total;
          this.size1 = res.data.data.size;
          this.tableData1 = res.data.data.records;
          this.loading1 = false;
          if (this.tableData1[0].auditStatus == 4 && this.page1 == 1) {
            this.red1 = true
          } else {
            this.red1 = false
          }
        }
        if (v == 2) {
          this.total2 = res.data.data.total;
          this.size2 = res.data.data.size;
          this.tableData2 = res.data.data.records;
          this.loading2 = false;
          if (this.tableData2[0].auditStatus == 4 && this.page2 == 1) {
            this.red2 = true
          } else {
            this.red2 = false
          }
        }
        if (v == 3) {
          this.total3 = res.data.data.total;
          this.size3 = res.data.data.size;
          this.tableData3 = res.data.data.records;
          this.loading3 = false;
          if (this.tableData3[0].auditStatus == 4 && this.page3 == 1) {
            this.red3 = true
          } else {
            this.red3 = false
          }
        }
        if (v == 4) {
          this.total4 = res.data.data.total;
          this.size4 = res.data.data.size;
          this.tableData4 = res.data.data.records;
          this.loading4 = false;
          if (this.tableData4[0].auditStatus == 4 && this.page4 == 1) {
            this.red4 = true
          } else {
            this.red4 = false
          }
        }
        if (v == 6) {
          this.total6 = res.data.data.total;
          this.size6 = res.data.data.size;
          this.tableData6 = res.data.data.records;
          this.loading6 = false;
          if (this.tableData6[0].auditStatus == 4 && this.page6 == 1) {
            this.red6 = true
          } else {
            this.red6 = false
          }
        } else if (v == 5) {
          this.total5 = res.data.data.total;
          this.size5 = res.data.data.size;
          this.tableData5 = res.data.data.records;
          this.loading5 = false;
        }
      }
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.handleSearch();
    },

    // 改变页码
    dialogsetCurrent(val) {
      this.dialogloading = true;
      this.dialogpage = val;
      companyAttendanceRecordPage({
        current: val,
        size: this.pageSize,
        companyAttendanceId: this.row.companyAttendanceId,
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    // 改变每页条数
    dialogsetPage(val) {
      this.dialogloading = true;
      this.pageSize = val;
      companyAttendanceRecordPage({
        current: 1,
        size: this.pageSize,
        companyAttendanceId: this.row.companyAttendanceId,
      }).then((res) => {
        this.dialogchangeData(res);
        this.$refs["dialogpages"].currentPage = 1; // 分页变成第一页
      });
    },
    setCurrentaffirm(val) {
      this.loadingaffirm = true;
      this.pageaffirm = val;
      companyAttendanceRecordPage({
        companyAttendanceId: this.row.companyAttendanceId,
        current: val,
        size: this.pageSizeaffirm,
      }).then((res) => {
        this.dialogchangeDataaffirm(res);
      });
    },
    // 改变每页条数
    setPageaffirm(val) {
      this.loadingaffirm = true;
      this.pageSizeaffirm = val;
      companyAttendanceRecordPage({
        current: 1,
        size: this.pageSizeaffirm,
        companyAttendanceId: this.row.companyAttendanceId,
      }).then((res) => {
        this.dialogchangeDataaffirm(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    setCurrent(val) {
      this.loading = true;
      const data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.page = val;
      companyAttendancePage({
        current: val,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true;
      const data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.pageSize = val;
      companyAttendancePage({
        current: 1,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    setCurrentb(val) {
      if (this.activeName == 1) {
        this.loading1 = true;
        this.page1 = val;
        companyAttendanceHolidayPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: val,
          size: this.pageSize1,
        }).then((res1) => {
          this.dialogchangeData(1, res1);
        });
      }
      if (this.activeName == 2) {
        this.loading2 = true;
        this.page2 = val;
        companyAttendanceWeekendPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: val,
          size: this.pageSize2,
        }).then((res1) => {
          this.dialogchangeData(2, res1);
        });
      }
      if (this.activeName == 3) {
        this.loading3 = true;
        this.page3 = val;
        companyAttendanceBusinessPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: val,
          size: this.pageSize1,
        }).then((res1) => {
          this.dialogchangeData(3, res1);
        });
      }
      if (this.activeName == 4) {
        this.loading4 = true;
        this.page4 = val;
        companyAttendanceNightPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: val,
          size: this.pageSize4,
        }).then((res1) => {
          this.dialogchangeData(4, res1);
        });
      }
      if (this.activeName == 6) {
        this.loading6 = true;
        this.page6 = val;
        companyAttendanceLeavePage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: val,
          size: this.pageSize6,
        }).then((res1) => {
          this.dialogchangeData(6, res1);
        });
      }
      if (this.activeName == 5) {
        this.loading5 = true;
        this.page5 = val;
        companyAttendanceRecordPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: val,
          size: this.pageSize5,
        }).then((res1) => {
          this.dialogchangeData(5, res1);
        });
      }
    },
    // 改变每页条数
    setPageb(val) {
      if (this.activeName == 1) {
        this.loading1 = true;
        this.pageSize1 = val;
        companyAttendanceHolidayPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: this.page1,
          size: val,
        }).then((res1) => {
          this.dialogchangeData(1, res1);
          this.$refs["pages1"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 2) {
        this.loading2 = true;
        this.pageSize2 = val;
        companyAttendanceWeekendPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: this.page2,
          size: val,
        }).then((res1) => {
          this.dialogchangeData(2, res1);
          this.$refs["pages2"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 3) {
        this.loading3 = true;
        this.pageSize3 = val;
        companyAttendanceBusinessPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: this.page3,
          size: val,
        }).then((res1) => {
          this.dialogchangeData(3, res1);
          this.$refs["pages3"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 4) {
        this.loading4 = true;
        this.pageSize4 = val;
        companyAttendanceNightPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: this.page4,
          size: val,
        }).then((res1) => {
          this.dialogchangeData(4, res1);
          this.$refs["pages4"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 6) {
        this.loading6 = true;
        this.pageSize6 = val;
        companyAttendanceLeavePage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: this.page6,
          size: val,
        }).then((res1) => {
          this.dialogchangeData(6, res1);
          this.$refs["pages6"].currentPage = 1; // 分页变成第一页
        });
      }
      if (this.activeName == 5) {
        this.loading5 = true;
        this.pageSize5 = val;
        companyAttendanceRecordPage({
          companyAttendanceId: this.row.companyAttendanceId,
          current: this.page5,
          size: val,
        }).then((res1) => {
          this.dialogchangeData(5, res1);
          this.$refs["pages5"].currentPage = 1; // 分页变成第一页
        });
      }
    },
    changeCountyCode(v, d) {
      this.countyCode = d.slice(-1)[0].id;
    },
    addOrganization() {
      this.$router.push({
        path: "/companyAttendance/uploadAttendance",
      });
    },
    editOrganization(row) {
      this.$router.push({
        path: "/companyAttendance/uploadAttendance",
        query: {
          companyAttendanceId: row.companyAttendanceId,
          attendanceDate: row.attendanceDate,
          deptId: row.deptId
        },
      });
    },
    cancelSubmit(row) {
      companyAttendanceCancelSubmit({
        companyAttendanceId: row.companyAttendanceId
      }).then((res) => {
        if (res.data.success) {
          this.handleSearch();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submitAudit(row) {
      companyAttendanceSubmitAudit({
        companyAttendanceId: row.companyAttendanceId,
      }).then((res) => {
        if (res.data.success) {
          this.handleSearch();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    audits() {
      console.log(this.activeName)
      console.log(this.subjectIdsw)
      if ((this.activeName == 1 && this.subjectIds) || (this.activeName == 2 && this.subjectIdsw) || (this.activeName == 3 && this.subjectIdsb) || (this.activeName == 4 && this.subjectIdsn) || (this.activeName == 6 && this.subjectIdsl)) {
        this.dialogVisible = true;
        this.asyncRoute.checkIdea = "";
        this.asyncRoute.pass = "1";
      } else {
        this.$message.error('请先选择待审核数据')
      }
    },
    audit(row) {
      //查看详情
      this.row = row;
      this.isput = true;
      companyAttendanceRecordPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.dialogchangeData(5, res);
        this.dialogTableVisible = true;
      });
      companyAttendanceHolidayPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(1, res1);
      });
      companyAttendanceWeekendPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(2, res1);
      });
      companyAttendanceBusinessPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(3, res1);
      });
      companyAttendanceNightPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(4, res1);
      });
      companyAttendanceLeavePage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res1) => {
        this.dialogchangeData(6, res1);
      });
    },
    auditclick() {
      if (!this.asyncRoute.checkIdea && this.asyncRoute.pass == "2") {
        this.$message.error("请填写审核意见");
        return;
      }
      let pass = true;
      if (this.asyncRoute.pass == "2") {
        pass = false;
      }
      if (this.activeName == 1) {
        companyAttendanceHolidayAudit({
          subjectIds: this.subjectIds,
          pass: pass,
          checkIdea: this.asyncRoute.checkIdea,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.dialogVisible = false;
            companyAttendanceHolidayPage({
              companyAttendanceId: this.row.companyAttendanceId,
              current: 1,
              size: 10,
            }).then((res1) => {
              this.dialogchangeData(1, res1);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.$message.error(error.response.data.msg)
        })
      }
      if (this.activeName == 2) {
        companyAttendanceWeekendAudit({
          subjectIds: this.subjectIdsw,
          pass: pass,
          checkIdea: this.asyncRoute.checkIdea,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.dialogVisible = false;
            companyAttendanceWeekendPage({
              companyAttendanceId: this.row.companyAttendanceId,
              current: 1,
              size: 10,
            }).then((res1) => {
              this.dialogchangeData(2, res1);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.$message.error(error.response.data.msg)
        })
      }
      if (this.activeName == 3) {
        companyAttendanceBusinessAudit({
          subjectIds: this.subjectIdsb,
          pass: pass,
          checkIdea: this.asyncRoute.checkIdea,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.dialogVisible = false;
            companyAttendanceBusinessPage({
              companyAttendanceId: this.row.companyAttendanceId,
              current: 1,
              size: 10,
            }).then((res1) => {
              this.dialogchangeData(3, res1);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.$message.error(error.response.data.msg)
        })
      }
      if (this.activeName == 4) {
        companyAttendanceNightAudit({
          subjectIds: this.subjectIdsn,
          pass: pass,
          checkIdea: this.asyncRoute.checkIdea,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.dialogVisible = false;
            companyAttendanceNightPage({
              companyAttendanceId: this.row.companyAttendanceId,
              current: 1,
              size: 10,
            }).then((res1) => {
              this.dialogchangeData(4, res1);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.$message.error(error.response.data.msg)
        })
      }
      if (this.activeName == 6) {
        companyAttendanceLeaveAudit({
          subjectIds: this.subjectIdsl,
          pass: pass,
          checkIdea: this.asyncRoute.checkIdea,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.dialogVisible = false;
            companyAttendanceLeavePage({
              companyAttendanceId: this.row.companyAttendanceId,
              current: 1,
              size: 10,
            }).then((res1) => {
              this.dialogchangeData(6, res1);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.$message.error(error.response.data.msg)
        })
      }
    },
    outs() {
      axios({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: `org/auth/companyAttendanceRecord/batchDownload`,
        responseType: "blob",
        method: "get",
        params: {companyAttendanceIds: this.companyAttendanceIds},
        headers: {
          Authorization: "Bearer " + localStorage.getItem("getToken"),
        },
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res.data], {type: "application/zip"});
        link.download = this.$moment(new Date()).format("YYYYMMDDHHmm");
        link.href = URL.createObjectURL(blob);
        link.click();
      });
    },
    out(row) {
      axios({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: `org/auth/companyAttendanceRecord/export`,
        responseType: "blob",
        method: "get",
        params: {companyAttendanceId: row.companyAttendanceId},
        headers: {
          Authorization: "Bearer " + localStorage.getItem("getToken"),
        },
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
        link.style.display = "none";
        link.download = "企业考勤明细信息.xlsx";
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      });
    },
    affirm(row) {
      this.row = row
      this.dialogaffirm = true
      companyAttendanceRecordPage({
        companyAttendanceId: row.companyAttendanceId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.dialogchangeDataaffirm(res);
        this.dialogaffirm = true;
      });
    },
    sx() {
      companyAttendanceRecordPage({
        companyAttendanceId: this.row.companyAttendanceId,
        current: this.pageaffirm,
        size: this.pageSizeaffirm
      }).then((res) => {
        this.dialogchangeDataaffirm(res);
        this.dialogaffirm = true;
      });
    },
    edit(scope) {
      if (scope.row.companyAttendanceRecordId == this.rowaffirm.companyAttendanceRecordId) {
        companyAttendanceRecordPut({
          ...this.fromAffirm,
          companyId: this.rowaffirm.companyId,
          attendanceDate: this.rowaffirm.attendanceDate,
          companyAttendanceId: this.rowaffirm.companyAttendanceId,
          companyAttendanceRecordId: scope.row.companyAttendanceRecordId
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.fromAffirm = {
              employeeAttendanceDays: '',
              employeeNightDays: '',
              employeeBusinessDays: '',
              employeeWeekendOvertimeDays: '',
              employeeHolidayOvertimeDays: '',
              employeeBusWorkCount: '',
              employeeTransferCount: '',
              employeeLeaveDays: '',
              employeeOther: ''
            }
            this.rowaffirm = {}
            this.sx()
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.$message.error(error.response.data.msg);
        })
      } else {
        this.rowaffirm = scope.row
        this.fromAffirm = {
          employeeAttendanceDays: scope.row.employeeAttendanceDays,
          employeeNightDays: scope.row.employeeNightDays,
          employeeBusinessDays: scope.row.employeeBusinessDays,
          employeeWeekendOvertimeDays: scope.row.employeeWeekendOvertimeDays,
          employeeHolidayOvertimeDays: scope.row.employeeHolidayOvertimeDays,
          employeeBusWorkCount: scope.row.employeeBusWorkCount,
          employeeTransferCount: scope.row.employeeTransferCount,
          employeeLeaveDays: scope.row.employeeLeaveDays,
          employeeOther: scope.row.employeeOther
        }
      }
    },
    affirmclick() {
      companyAttendanceAudit({
        subjectId: this.row.companyAttendanceId,
        pass: true,
        checkIdea: ''
      }).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.dialogaffirm = false;
          this.rowaffirm = {}
          this.handleSearch()
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {
        console.log(error.response)
        this.$message.error(error.response.data.msg);
      })
    },
    selectHandle(row) {
      return row.auditStatus == 2
    },
    close() {
      console.log(123)
      this.handleSearch()
    },
    rollback(id) {
      this.$Modal.confirm({
        title: '确认退回？',
        onOk: () => {
          companyAttendanceRollback(id).then((res) => {
            console.log(res)
            console.log(res.data.success)
            if (res.data.success) {
              console.log(1)
              this.$Message.success(res.data.msg)
              this.init()
            } else {
              console.log(2)
              this.$Message.error(res.data.msg)
            }
          }).catch(() => {
            this.$Message.error('退回失败')
          })
        },
        onCancel: () => {
          this.$Message.info('已取消退回')
        }
      })
    }
  },
};
</script>
